<template>
  <footer class="site-footer">
    <div class="container site-footer__grid">
      <div class="site-footer__column">
        <h4>{{ content.membershipTitle }}</h4>
        <p v-for="line in content.membershipLines" :key="line">{{ line }}</p>
      </div>
      <div class="site-footer__column">
        <h4>{{ content.contactTitle }}</h4>
        <p v-for="line in content.contactLines" :key="line">{{ line }}</p>
      </div>
      <div class="site-footer__column site-footer__column--company">
        <div class="site-footer__brand">{{ content.companyName }}</div>
        <p
          v-for="(line, index) in content.companyLines"
          :key="line"
          :class="[
            'site-footer__line',
            { 'site-footer__line--label': content.companyLabelIndexes.indexOf(index) !== -1 }
          ]"
        >
          {{ line }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
var footerContent = {
  en: {
    membershipTitle: 'Memberships and Partner Company',
    membershipLines: [
      'Member of JNTO (Japan National Tourism Organization)',
      'Partner Company:',
      'DMCFinder,',
      'Japan-China Friendship Association,',
      'Rakuten Bank,',
      'JTB Corporation,',
      'China Central Television,',
      'China Photographers Association'
    ],
    contactTitle: 'Contact Us',
    contactLines: [
      'E-Mail: tokyo02@jbc-japan.co.jp',
      'WhatsApp ID: 81 80-5241-7850',
      'All emails will be responded to within 24 hours.'
    ],
    companyName: 'JBC TOURS',
    companyLines: [
      'Headquarter:',
      'Sausuwin Building 5F, 2-14-30 Ebisu-nishi, Naniwa-ku, Osaka City, Osaka Prefecture, Japan 556-0003',
      'Tokyo Branch',
      'Room 502, Kisuke Kudan-kita Building, 1-4-7 Kudan-kita, Chiyoda-ku, Tokyo 102-0073',
      'Tel: 81-3-6869-4765',
      'Fax:03-6869-4769'
    ],
    companyLabelIndexes: [0, 2]
  },
  ja: {
    membershipTitle: 'コンプライアンス',
    membershipLines: [
      '日本政府観光局(JNTO)会員',
      '連携先:',
      'DMCFinder、',
      '日中友好協会、',
      '楽天銀行、',
      '株式会社JTB、',
      '中国中央テレビ局、',
      '中国撮影家協会'
    ],
    contactTitle: 'お問い合わせ',
    contactLines: [
      'メールアドレス：tokyo02@jbc-japan.co.jp',
      'WhatsApp ID:81 80-5241-7850',
      'メールでのお問合せは24時間受け付けております。'
    ],
    companyName: 'JBC TOURS',
    companyLines: [
      '本　　　社',
      '〒556-0003　大阪市浪速区恵美須西2-14-30サウスウィンビル5F',
      '東京支社',
      '〒102-0073 東京都千代田区九段北1-4-7 喜助九段北ビル502号室',
      'Tel:81-3-6869-4765'
    ],
    companyLabelIndexes: [0, 2]
  }
};

export default {
  name: 'SiteFooter',
  props: {
    language: {
      type: String,
      default: 'en'
    }
  },
  computed: {
    content: function () {
      return footerContent[this.language] || footerContent.en;
    }
  }
};
</script>

<style scoped>
.site-footer {
  padding: 56px 0 42px;
  border-top: 1px solid var(--color-line);
  background: rgba(255, 252, 248, 0.72);
}

.site-footer__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 32px;
  align-items: start;
}

.site-footer__column {
  display: grid;
  gap: 12px;
}

.site-footer__column--company {
  gap: 8px;
}

.site-footer__brand {
  font-size: 18px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  margin-bottom: 4px;
}

h4 {
  margin: 0 0 4px;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 12px;
}

p {
  margin: 0;
  color: var(--color-muted);
  line-height: 1.8;
}

.site-footer__line--label {
  margin-top: 6px;
  color: var(--color-text);
  font-weight: 600;
  line-height: 1.5;
}

@media (max-width: 1023px) {
  .site-footer__grid {
    grid-template-columns: 1fr;
  }
}
</style>
